// Helpers for rendering position <-> user relationships.
//
// A position may hold MULTIPLE active users at once (the backend "position
// filled" guard was removed). The detail API returns the full set
// via `users`, while the list API and older responses only carry the single
// current user via the scalar `user_name` / `user_email` fields.

/**
 * Returns every user assigned to a position as an array of
 * `{ user_name, user_email }`. Prefers the `users` array from the detail API;
 * falls back to the single current user for the list view / backward compat.
 *
 * @param {object} position
 * @returns {Array<{ user_name?: string, user_email?: string }>}
 */
export const getAssignedUsers = (position = null) => {
  if (!position) return [];

  if (Array.isArray(position.users) && position.users.length > 0) {
    return position.users;
  }

  if (position.user_email || position.user_name) {
    return [{ user_name: position.user_name, user_email: position.user_email }];
  }

  return [];
};

/**
 * Resolves which user an expel action should target. When a specific `user` is
 * picked (multi-user position), that user wins; otherwise it falls back to the
 * position's current user.
 *
 * @param {object|null} user
 * @param {object} position
 * @returns {{ user_email: string, user_name: string }}
 */
export const getExpelTarget = (user, position = null) => ({
  user_email: (user && user.user_email) || position?.user_email || '',
  user_name: (user && user.user_name) || position?.user_name || '',
});
